import { render, staticRenderFns } from "./UserBookingDetails.vue?vue&type=template&id=0c02e0db"
import script from "./UserBookingDetails.vue?vue&type=script&lang=js"
export * from "./UserBookingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports